import { Units } from 'types/trackmanParameters';

const unitMapping: { [key: string]: Units } = {
  deg: Units.deg,
  kmph: Units.kmph,
  meters: Units.meters,
  mph: Units.mph,
  mps: Units.mps,
  rpm: Units.rpm,
  yards: Units.yards,
};

export const unitNamesMapper = (unit: string) => {
  return unitMapping[unit] || unit;
};

export const cultureToUnitsMapper = (culture: string) => {
  switch (culture) {
    case 'en-US':
      return ['yards', 'mph', 'deg', 'rpm', 'withoutUnit'];
    case 'ja-JP':
      return ['meters', 'mps', 'deg', 'rpm', 'withoutUnit'];
    case 'ko-KR':
      return ['mph', 'deg', 'mps', 'rpm', 'withoutUnit'];
    case 'en-GB':
      return ['meters', 'kmph', 'deg', 'rpm', 'withoutUnit'];
    default:
      return ['yards', 'mph', 'deg', 'rpm', 'withoutUnit'];
  }
};
